import {FETCH_WATCH_LIVE_IMAGES} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_WATCH_LIVE_IMAGES:
            return action.payload;
        default:
            return state;
    }
}